import authentication from './authentication';
import authorization from './authorization';
import bootstrap from './bootstrap';
import props from './props';
import redirect from './redirect';
import api from './api';
import lang from './lang';

export default {
    authentication,
    authorization,
    bootstrap,
    props,
    redirect,
    api,
	lang
};
